export default __webpack_public_path__ + "static/school_filming-17ba96c97936947839cada0ae8b8e54c.jpg";